import { Button, Collapse, FormControlLabel, Switch } from "@mui/material";
import axios from "axios";
import React, { useState } from "react";
import Calendar from "react-calendar";
import { useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../../Config/axios";
import { API_URLS } from "../../Config/API_URLS";

export default function Weekly() {
  const { id,variant_id } = useParams();
  const navigate = useNavigate();
  const [sunday, setSunday] = useState("");
  const [monday, setMonday] = useState("");
  const [tuesday, setTuesday] = useState("");
  const [wednesday, setWednesday] = useState("");
  const [thursday, setThursday] = useState("");
  const [friday, setFriday] = useState("");
  const [saturday, setSaturday] = useState("");
  const [sundayv, setSundayv] = useState(0);
  const [mondayv, setMondayv] = useState(0);
  const [tuesdayv, setTuesdayv] = useState(0);
  const [wednesdayv, setWednesdayv] = useState(0);
  const [thursdayv, setThursdayv] = useState(0);
  const [fridayv, setFridayv] = useState(0);
  const [saturdayv, setSaturdayv] = useState(0);
  const [value1, setValue1] = useState("");
  const [checked, setChecked] = React.useState(false);
  const [checked2, setChecked2] = React.useState(false);
  const [checked3, setChecked3] = React.useState(false);
  const [checked4, setChecked4] = React.useState(false);
  const [checked5, setChecked5] = React.useState(false);
  const [checked6, setChecked6] = React.useState(false);
  const [checked7, setChecked7] = React.useState(false);
  const [checked8, setChecked8] = React.useState(false);
  const [count, setCount] = useState(0);

  const handleChange = () => {
    setChecked((prev) => !prev);
    setMonday("Monday");
  };
  const handleChange2 = () => {
    setChecked2((prev) => !prev);
    setTuesday("Tuesday");
  };
  const handleChange3 = () => {
    setChecked3((prev) => !prev);
    setWednesday("Wednesday");
  };
  const handleChange4 = () => {
    setChecked4((prev) => !prev);
    setThursday("Thursday");
  };
  const handleChange5 = () => {
    setChecked5((prev) => !prev);
    setFriday("Friday");
  };
  const handleChange6 = () => {
    setChecked6((prev) => !prev);
    setSaturday("saturday");
  };
  const handleChange7 = () => {
    setChecked7((prev) => !prev);
    setSunday("Sunday");
  };
  const handleChange8 = () => {
    setChecked8(true);
  };

  const GetSubscriptionDaly = () => {
    // const reqbody = new FormData();
    // reqbody.append("subscription_plan_id", id);
    // reqbody.append("product_variants_id", 1);
    // reqbody.append("start_date", convert(value1));
    // reqbody.append("select_quantity", count);

    const reqbody = {
      subscription_plan_id: id,
      product_variants_id: variant_id,
      weekly_subscription_details: {
        start_date: convert(value1),
        days: [
          {
            day_name: "Sunday",
            quantity: sundayv,
          },
          {
            day_name: "Monday",
            quantity: mondayv,
          },
          {
            day_name: "Tuesday",
            quantity: tuesdayv,
          },
          {
            day_name: "Wedensday",
            quantity: wednesdayv,
          },
          {
            day_name: "Thursday",
            quantity: thursdayv,
          },
          {
            day_name: "Friday",
            quantity: fridayv,
          },
          {
            day_name: "Saturday",
            quantity: saturdayv,
          },
        ],
      },
    };
    axiosInstance
    .post(API_URLS.weeklySubscription, reqbody)
    .then((response) => {
      alert(response?.data?.message);
      navigate("/subscription");
    })
    .catch((error) => {
      console.log(error);
    });
    
  };

  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }
  console.log("day", convert(value1));

  return (
    <>
      <div className="flex mt-32">
        <div className="flex px-5">
          <div className="px-5">
            <img
              src="https://cdn.pixabay.com/photo/2017/09/26/13/42/apple-2788662_1280.jpg"
              alt=""
              className="h-20 w-20 "
            />
          </div>
          <div className=" flex flex-col justify-start items-start">
            <p className="font-bold">Tender Coconut clean & Peeled</p>
            <p className="text-gray-300">1 pc</p>
          </div>
        </div>
      </div>
      <div className="flex flex-col justify-start items-start my-16 px-5">
        <p className="font-bold text-xl">Select Day(s) for Delivery</p>
        <div
          onClick={handleChange8}
          className="flex flex-row justify-between items-center w-full my-5"
        >
          <p onClick={handleChange} className="bg-blue-200 p-3 rounded-md">
            Mo
          </p>
          <p onClick={handleChange2} className="bg-blue-200 p-3 rounded-md">
            Tu
          </p>
          <p onClick={handleChange3} className="bg-blue-200 p-3 rounded-md">
            We
          </p>
          <p onClick={handleChange4} className="bg-blue-200 p-3 rounded-md">
            Th
          </p>
          <p onClick={handleChange5} className="bg-blue-200 p-3 rounded-md">
            Fr
          </p>
          <p onClick={handleChange6} className="bg-blue-200 p-3 rounded-md">
            Sa
          </p>
          <p onClick={handleChange7} className="bg-blue-200 p-3 rounded-md">
            Su
          </p>
        </div>
      </div>

      <div className="lg:flex flex-row justify-center items-center lg:gap-10">
        <div>
          <Collapse in={checked}>
            <div className="flex flex-row justify-between items-center w-full px-3 my-2">
              <div className="flex ">
                <p className="text-gray-600 text-xl ">Monday</p>
                <p className="mt-1"> of every week</p>
              </div>
              <span>
                <span
                  className="bg-blue-200 p-3 rounded-md"
                  onClick={() => setMondayv(mondayv - 1)}
                >
                  -
                </span>{" "}
                <span className="bg-blue-200 p-3 rounded-md">{mondayv}</span>{" "}
                <span
                  className="bg-blue-200 p-3 rounded-md"
                  onClick={() => setMondayv(mondayv + 1)}
                >
                  +
                </span>
              </span>
            </div>
          </Collapse>
          <Collapse in={checked2}>
            <div className="flex flex-row justify-between items-center w-full px-3 my-2">
              <div className="flex ">
                <p className="text-gray-600 text-xl ">Tuesday</p>
                <p className="mt-1"> of every week</p>
              </div>
              <span>
                <span
                  className="bg-blue-200 p-3 rounded-md"
                  onClick={() => setTuesdayv(tuesdayv - 1)}
                >
                  -
                </span>{" "}
                <span className="bg-blue-200 p-3 rounded-md">{tuesdayv}</span>{" "}
                <span
                  className="bg-blue-200 p-3 rounded-md"
                  onClick={() => setTuesdayv(tuesdayv + 1)}
                >
                  +
                </span>
              </span>
            </div>
          </Collapse>
          <Collapse in={checked3}>
            <div className="flex flex-row justify-between items-center w-full px-3 my-2">
              <div className="flex ">
                <p className="text-gray-600 text-xl">Wednesday</p>
                <p className="mt-1"> of every week</p>
              </div>
              <span>
                <span
                  className="bg-blue-200 p-3 rounded-md"
                  onClick={() => setWednesdayv(wednesdayv - 1)}
                >
                  -
                </span>{" "}
                <span className="bg-blue-200 p-3 rounded-md">{wednesdayv}</span>{" "}
                <span
                  className="bg-blue-200 p-3 rounded-md"
                  onClick={() => setWednesdayv(wednesdayv + 1)}
                >
                  +
                </span>
              </span>
            </div>
          </Collapse>
          <Collapse in={checked4}>
            <div className="flex flex-row justify-between items-center w-full px-3 my-2">
              <div className="flex ">
                <p className="text-gray-600 text-xl ">Thursday</p>
                <p className="mt-1"> of every week</p>
              </div>
              <span>
                <span
                  className="bg-blue-200 p-3 rounded-md"
                  onClick={() => setThursdayv(thursdayv - 1)}
                >
                  -
                </span>{" "}
                <span className="bg-blue-200 p-3 rounded-md">{thursdayv}</span>{" "}
                <span
                  className="bg-blue-200 p-3 rounded-md"
                  onClick={() => setThursdayv(thursdayv + 1)}
                >
                  +
                </span>
              </span>
            </div>
          </Collapse>
          <Collapse in={checked5}>
            <div className="flex flex-row justify-between items-center w-full px-3 my-2">
              <div className="flex ">
                <p className="text-gray-600 text-xl ">Friday</p>
                <p className="mt-1"> of every week</p>
              </div>
              <span>
                <span
                  className="bg-blue-200 p-3 rounded-md"
                  onClick={() => setFridayv(fridayv - 1)}
                >
                  -
                </span>{" "}
                <span className="bg-blue-200 p-3 rounded-md">{fridayv}</span>{" "}
                <span
                  className="bg-blue-200 p-3 rounded-md"
                  onClick={() => setFridayv(fridayv + 1)}
                >
                  +
                </span>
              </span>
            </div>
          </Collapse>
          <Collapse in={checked6}>
            <div className="flex flex-row justify-between items-center w-full px-3 my-2">
              <div className="flex ">
                <p className="text-gray-600 text-xl ">Saturday</p>
                <p className="mt-1"> of every week</p>
              </div>
              <span>
                <span
                  className="bg-blue-200 p-3 rounded-md"
                  onClick={() => setSaturdayv(saturdayv - 1)}
                >
                  -
                </span>{" "}
                <span className="bg-blue-200 p-3 rounded-md">{saturdayv}</span>{" "}
                <span
                  className="bg-blue-200 p-3 rounded-md"
                  onClick={() => setSaturdayv(saturdayv + 1)}
                >
                  +
                </span>
              </span>
            </div>
          </Collapse>
          <Collapse in={checked7}>
            <div className="flex flex-row justify-between items-center w-full px-3 my-2">
              <div className="flex ">
                <p className="text-gray-600 text-xl ">Sunday</p>
                <p className="mt-1"> of every week</p>
              </div>
              <span>
                <span
                  className="bg-blue-200 p-3 rounded-md"
                  onClick={() => setSundayv(sundayv - 1)}
                >
                  -
                </span>{" "}
                <span className="bg-blue-200 p-3 rounded-md">{sundayv}</span>{" "}
                <span
                  className="bg-blue-200 p-3 rounded-md"
                  onClick={() => setSundayv(sundayv + 1)}
                >
                  +
                </span>
              </span>
            </div>
          </Collapse>
        </div>
        <Collapse in={checked8}>
          <div className="my-5">
            <Calendar onChange={setValue1} value={value1} />
          </div>
        </Collapse>
      </div>
      <Button onClick={GetSubscriptionDaly} variant="contained">
      Confirm
      </Button>
    </>
  );
}
